import React from 'react';

export default function IconES() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#C8414B"
                d="M.553 21.483h30.896a.552.552 0 0 0 .552-.552V1.07a.552.552 0 0 0-.552-.552H.553A.552.552 0 0 0 0 1.07v19.862c0 .305.247.552.552.552Z"
            />
            <path fill="#FFD250" d="M32.001 4.931h-32V17.07h32V4.93Z" />
            <path
                fill="#C8414B"
                d="m13.518 11 .468-2.105a.31.31 0 0 0-.303-.378h-.33a.31.31 0 0 0-.303.378L13.518 11Z"
            />
            <path fill="#F5F5F5" d="M14.07 9.896h-1.103v4.69h1.103v-4.69Z" />
            <path fill="#FAB446" d="M14.345 9.345H12.69v.552h1.655v-.552Z" />
            <path
                fill="#C8414B"
                d="M14.347 11h-2.759v.552h2.759V11ZM14.347 13.207l-1.655-.552v-.552l1.655.552v.552ZM5.243 11l.468-2.105a.31.31 0 0 0-.303-.378h-.33a.31.31 0 0 0-.302.378L5.243 11Z"
            />
            <path
                fill="#F5F5F5"
                d="M7.174 9.345a.552.552 0 0 0-.552.552v3.586c0 .67.626 1.931 2.759 1.931s2.758-1.26 2.758-1.931V9.897a.552.552 0 0 0-.552-.552H7.174Z"
            />
            <path
                fill="#C8414B"
                d="M9.381 12.104H6.623V9.896c0-.305.247-.552.551-.552h2.207v2.758Z"
            />
            <path fill="#C8414B" d="M9.381 12.104h2.759v1.379a1.38 1.38 0 1 1-2.759 0v-1.38Z" />
            <path fill="#FAB446" d="M6.622 12.104H9.38v1.379a1.38 1.38 0 1 1-2.76 0v-1.38Z" />
            <path
                fill="#C8414B"
                d="M8.828 14.58v-2.476h-.552v2.73c.205-.041.39-.132.552-.254ZM7.724 14.834v-2.73h-.552v2.476c.162.122.347.213.552.254Z"
            />
            <path fill="#FFB441" d="M8.829 11H7.174v.552h1.655V11Z" />
            <path fill="#FAB446" d="M8.829 9.896H7.174v.552h1.655v-.552Z" />
            <path fill="#FAB446" d="M8.552 10.225H7.45v.999h1.103v-1Z" />
            <path fill="#F5F5F5" d="M5.794 9.896H4.69v4.69h1.104v-4.69Z" />
            <path
                fill="#FAB446"
                d="M6.069 14.31H4.414v.552h1.655v-.551ZM6.069 9.345H4.414v.552h1.655v-.552Z"
            />
            <path fill="#5064AA" d="M6.346 14.862H4.139v.552h2.207v-.552Z" />
            <path fill="#FAB446" d="M14.622 14.31h-1.655v.552h1.655v-.551Z" />
            <path fill="#5064AA" d="M14.621 14.862h-2.206v.552h2.206v-.552Z" />
            <path fill="#FAB446" d="M11.036 8.793h-3.31v.552h3.31v-.552Z" />
            <path fill="#FFB441" d="M9.657 7.138h-.552v1.655h.552V7.138Z" />
            <path
                fill="#F5F5F5"
                d="M8.829 7.966a.828.828 0 0 1 0-1.656.828.828 0 0 1 0 1.656Zm0-1.104a.276.276 0 1 0 0 .552.276.276 0 0 0 0-.552Z"
            />
            <path
                fill="#F5F5F5"
                d="M9.932 7.966a.828.828 0 0 1 0-1.656.828.828 0 0 1 0 1.656Zm0-1.104a.276.276 0 1 0 0 .552.276.276 0 0 0 0-.552Z"
            />
            <path
                fill="#F5F5F5"
                d="M11.036 8.517a.828.828 0 0 1 0-1.655.828.828 0 0 1 0 1.655Zm0-1.103a.276.276 0 1 0 0 .552.276.276 0 0 0 0-.552ZM7.725 8.517a.828.828 0 0 1 0-1.655.828.828 0 0 1 0 1.655Zm0-1.103a.276.276 0 1 0 0 .552.276.276 0 0 0 0-.552Z"
            />
            <path
                fill="#FAB446"
                d="M11.035 13.207v.276a.276.276 0 0 1-.551 0v-.276h.551Zm.552-.552H9.932v.828a.828.828 0 0 0 1.655 0v-.828Z"
            />
            <path
                fill="#FFA0D2"
                d="M10.76 11.552a.552.552 0 0 1-.552-.552v-.552a.552.552 0 0 1 1.104 0V11a.552.552 0 0 1-.552.552Z"
            />
            <path fill="#5064AA" d="M9.38 12.93a.828.828 0 1 0 0-1.654.828.828 0 0 0 0 1.655Z" />
            <path fill="#FAB446" d="M9.657 6.035h-.552V7.69h.552V6.035Z" />
            <path
                fill="#C8414B"
                d="m7.725 8.793-.552-.551.323-.324a2.664 2.664 0 0 1 3.768 0l.323.324-.552.551h-3.31Z"
            />
            <path
                fill="#FFD250"
                d="M9.38 8.517a.276.276 0 1 0 0-.552.276.276 0 0 0 0 .552ZM8.276 8.517a.276.276 0 1 0 0-.552.276.276 0 0 0 0 .552ZM10.483 8.517a.276.276 0 1 0 0-.552.276.276 0 0 0 0 .552Z"
            />
            <path
                fill="#C8414B"
                d="M7.172 11H4.414v.552h2.758V11ZM4.414 13.207l1.655-.552v-.551l-1.655.551v.552Z"
            />
        </svg>
    );
}
